<template>
  <div class="valid-box">
    <van-form validate-first @submit="onSubmit">
      <van-field
        :value="form.phone"
        readonly
        type="tel"
        :name="$t('options.当前手机号')"
        :label="$t('options.当前手机号')"
      />
      <van-field
        :value="form.new_phone"
        readonly
        type="tel"
        :name="$t('options.新手机号')"
        :label="$t('options.新手机号')"
        :placeholder="$t('options.请输入新手机号码')"
      />
      <van-field
        v-model="code"
        :name="$t('options.新手机验证码')"
        :label="$t('options.新手机验证码')"
        :placeholder="$t('options.请输入新手机短信验证码')"
        :rules="[{ required: true, message: $t('options.请输入短信验证码') }]"
      >
        <template #button>
          <van-button
            native-type="button"
            @click="getSms"
            type="primary"
            size="mini"
            >{{
              showTimer
                ? `${$t("options.重新发送")}(${second}s)`
                : $t("options.发送验证码")
            }}
          </van-button>
        </template>
      </van-field>
      <div style="margin: 16px;">
        <van-button
          class="login-btn"
          block
          type="primary"
          size="large"
          :loading="submitLoading"
          native-type="submit"
        >
          {{ $t("options.确定") }}
        </van-button>
      </div>
      <div class="back-top">
        <span @click="handleBack">{{ $t("options.返回上一步") }}</span>
      </div>
    </van-form>
  </div>
</template>

<script>
import { sendVerifyCode, selfChangePhone } from "@/api/user";
import storage from "@/utils/storage";

export default {
  props: {
    form: {
      type: Object,
      default: () => ({
        phone: "",
        new_phone: "",
      }),
    },
    content: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      code: "",
      showTimer: false,
      second: 0,
      timer: null,
      submitLoading: false,
    };
  },
  created() {
    this.getSms();
  },
  beforeUnmount() {
    if (this.timer) {
      this.second = 0;
      this.showTimer = false;
      clearInterval(this.timer);
    }
  },
  methods: {
    handleBack() {
      this.$emit("handleBack");
    },
    getSms() {
      const { new_phone } = this.form;
      let params = {
        phone: new_phone,
      };
      if (this.showTimer) {
        return;
      }
      sendVerifyCode(params).then((res) => {
        if (res.code === 0) {
          this.showTimer = true;
          this.second = 60;
          this.timer = setInterval(() => {
            this.second = this.second - 1;
            if (this.second === 0) {
              this.showTimer = false;
              clearInterval(this.timer);
              return;
            }
          }, 1000);
        }
      });
    },
    onSubmit() {
      const { phone, new_phone } = this.form;
      const params = {
        code: this.code,
        content: `HBSJ${this.content}`,
        phone,
        new_phone,
      };
      this.submitLoading = true;
      selfChangePhone(params)
        .then((res) => {
          if (res.code === 0) {
            window.staticFn.customEvent("submit_report", {
              type: "rebind_phone",
              game_id: storage.getGameId(),
            });
            this.$emit("submit");
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.valid-box {
  width: 100%;
  .back-top {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1890ff;
  }
}
</style>
